import React, { lazy } from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { BarChart3, BookOpen, Check, Gift, Package, Search, ShieldCheck, Sparkles, Truck, Upload, Zap } from 'lucide-react';
const MASTER_SYSTEM_CHECKOUT = 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026';
const modules = [{
  number: '01',
  icon: BookOpen,
  title: 'Introducción y fundamentos',
  description: 'Entiende el ecosistema de Amazon y prepara una base clara.'
}, {
  number: '02',
  icon: Package,
  title: 'Amazon FBA',
  description: 'Conoce el modelo logístico de Amazon paso a paso.'
}, {
  number: '03',
  icon: Truck,
  title: 'Amazon FBM',
  description: 'Aprende a gestionar ventas y envíos con mayor control.'
}, {
  number: '04',
  icon: Search,
  title: 'Investigación de productos',
  description: 'Analiza oportunidades antes de tomar decisiones.'
}, {
  number: '05',
  icon: Upload,
  title: 'Publicación y optimización',
  description: 'Crea listings claros y optimizados para vender.'
}, {
  number: '06',
  icon: BarChart3,
  title: 'Escalamiento',
  description: 'Organiza tus próximos pasos para hacer crecer el proceso.'
}];
const bonuses = [{
  title: 'Lista de Productos Listos para Vender en Amazon',
  description: 'Encuentra oportunidades reales listas para vender sin pasar semanas investigando.',
  value: '$47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/5gLe8NQ3THB6p4g2LezwHL/bono1.png'
}, {
  title: 'Plantilla Premium para Elegir Productos Ganadores',
  description: 'Evalúa cualquier producto antes de invertir dinero.',
  value: '$37 USD',
  image: 'https://cdn.magicpatterns.com/uploads/usHW9zxmKsgZeje6BAhBtY/bono2.png'
}, {
  title: 'Checklist Completo',
  description: 'Lanza tu primer producto con una ruta clara y sin omitir pasos importantes.',
  value: '$47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/su8kBNUb2rzH2dnBSzVu6y/bono3.png'
}, {
  title: 'Guía para Envíos FBM y Reducción de Costos',
  description: 'Reduce costos operativos y gestiona tus envíos con más seguridad.',
  value: '$47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/xAnzayhAtYWJic7NsSszrJ/Bono_1_FBM.png'
}, {
  title: 'Cómo Hacer Campañas Publicitarias en Amazon Seller para FBM',
  description: 'Aprende a generar visibilidad y ventas con campañas mejor estructuradas.',
  value: '$57 USD',
  image: 'https://cdn.magicpatterns.com/uploads/koFW9j1ka9PMEAGeSziZNj/bono_2_FBM.png'
}, {
  title: 'Guía Completa para Conseguir Proveedores',
  description: 'Encuentra mejores opciones y aprende a negociar con mayor confianza.',
  value: '$67 USD',
  image: 'https://cdn.magicpatterns.com/uploads/vn5FP15F1zWD2barJSa1nx/bono_3_FBM.png'
}];
const completeSystems = [{
  label: 'Sistema completo 01',
  title: 'Amazon FBA Master System™',
  image: 'https://cdn.magicpatterns.com/uploads/5iqvxYkdj1JSa7kZ4Yh184/ChatGPT_Image_14_jul_2026,_06_17_14.png',
  alt: 'Amazon FBA Master System, programa digital completo de Amazon FBA',
  features: ['Curso completo desde cero', 'Método paso a paso', 'Herramientas profesionales', 'Acceso inmediato']
}, {
  label: 'Sistema completo 02',
  title: 'Amazon FBM Master System™',
  image: 'https://cdn.magicpatterns.com/uploads/kNfNRjNNdwCHbzRVrk1av6/ChatGPT_Image_14_jul_2026,_06_17_25.png',
  alt: 'Amazon FBM Master System, programa digital completo de Amazon FBM',
  features: ['Venta sin inventario', 'Proveedores', 'Campañas para Amazon', 'Guía de envíos']
}];
export function QueAprenderas() {
  const goToCheckout = () => {
    window.open(MASTER_SYSTEM_CHECKOUT, '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-white px-5 py-20 sm:px-6 md:py-28" data-id="element-704" data-mp="38a9mgska9prg">
      <div className="mx-auto max-w-6xl" data-id="element-705" data-mp="38cmc7rwa94f2">
        <FadeIn data-id="element-706" data-mp="33c8306iy3ofg">
          <div className="mx-auto mb-12 max-w-3xl text-center md:mb-16" data-id="element-707" data-mp="33an8ggwms5hl">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-708" data-mp="3hbpvavvg9jtk">
              Dentro del programa
            </p>
            <h2 className="font-serif text-3xl font-bold tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-709" data-mp="3dae44lwxgqj9">
              Un método completo para aprender y aplicar.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5" data-id="element-710" data-mp="2kj45ga2lwrfk">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <FadeIn key={module.number} delay={0.06 * index} data-id="element-711" data-mp="2tjixdsa2t4s1" data-mpi={index}>
                <article className="relative h-full overflow-hidden rounded-2xl border border-brand-text/8 bg-white p-6 shadow-[0_10px_32px_-22px_rgba(26,26,26,0.24)]" data-id="element-712" data-mp="25uq5c6wkrh2p">
                  <span className="absolute right-5 top-4 text-5xl font-bold leading-none text-brand-green/5" data-id="element-713" data-mp="1rpz9r95i3v6u">
                    {module.number}
                  </span>
                  <span className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-green/8" data-id="element-714" data-mp="1wj243ji3r8o3">
                    <Icon className="h-5 w-5 text-brand-green" data-id="element-715" data-mp="1mr66e9jxhkke" />
                  </span>
                  <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-716" data-mp="2ah0i2nsih332">
                    Módulo {Number(module.number)}
                  </p>
                  <h3 className="mt-2 text-lg font-bold text-brand-green" data-id="element-717" data-mp="2ffbqcu35r5j6">
                    {module.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-brand-text/65" data-id="element-718" data-mp="25hnkp940kdm8">
                    {module.description}
                  </p>
                </article>
              </FadeIn>;
        })}
        </div>

        <div className="mt-20 border-t border-brand-text/10 pt-20 md:mt-24 md:pt-24" data-id="element-719" data-mp="u3tjfy9uvaqk">
          <FadeIn data-id="element-720" data-mp="2wpp5qxjd3eqx">
            <header className="mx-auto max-w-4xl text-center" data-id="element-721" data-mp="2wo4b77x1rvt2">
              <span className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border border-brand-gold/30 bg-brand-gold/10" data-id="element-722" data-mp="2rqkzaentnv4a">
                <Gift className="h-7 w-7 text-brand-gold" data-id="element-723" data-mp="2my1lbgl82xyy" />
              </span>
              <h2 className="font-serif text-3xl font-bold leading-tight tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-724" data-mp="2hzhyzf2pvk62">
                🎁 Todo esto está incluido con tu acceso
              </h2>
              <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-brand-text/70 sm:text-lg" data-id="element-725" data-mp="28z1x2a1mgl3b">
                Cuando compras Amazon Master System™ no solo recibes el
                programa principal. También obtienes herramientas, plantillas,
                estrategias y guías premium diseñadas para ayudarte a avanzar
                más rápido, evitar errores costosos y aumentar tus posibilidades
                de éxito.
              </p>
            </header>
          </FadeIn>

          <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-7" data-id="element-726" data-mp="4t1t4u6lxv1w">
            {bonuses.map((bonus, index) => <FadeIn key={bonus.title} delay={0.05 * (index % 4)} data-id="element-727" data-mp="9qtibgfvb32e" data-mpi={index}>
                <article className="flex h-full flex-col overflow-hidden rounded-3xl border border-brand-text/10 bg-[#FCFBF8] p-5 shadow-[0_16px_45px_-28px_rgba(26,26,26,0.3)] sm:p-6" data-id="element-728" data-mp="ekxqg30vdh52">
                  <div className="overflow-hidden rounded-2xl border border-brand-gold/20 bg-white" data-id="element-729" data-mp="3i1ela0g2frl4">
                    <img src={bonus.image} alt={bonus.title} loading="lazy" className="h-auto w-full object-contain" data-id="element-730" data-mp="3n0hfsqyf6feu" />
                  </div>

                  <div className="flex flex-grow flex-col px-1 pb-1 pt-6" data-id="element-731" data-mp="pvgn4swj7mz">
                    <span className="mb-3 inline-flex w-fit rounded-full border border-brand-gold/35 bg-brand-gold/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-brand-green" data-id="element-732" data-mp="1780pqxdddvwd">
                      BONO PREMIUM #{index + 1}
                    </span>
                    <h3 className="text-xl font-bold leading-tight text-brand-green" data-id="element-733" data-mp="1sddzbdq7ycxz">
                      {bonus.title}
                    </h3>
                    <p className="mt-3 flex-grow text-base leading-relaxed text-brand-text/70" data-id="element-734" data-mp="27320meyehblp">
                      {bonus.description}
                    </p>
                    <div className="mt-6 flex items-center justify-between border-t border-brand-text/10 pt-5" data-id="element-735" data-mp="2g0c95sju2mmx">
                      <span className="text-xs font-bold uppercase tracking-[0.14em] text-brand-text/50" data-id="element-736" data-mp="2c025wnnfeabr">
                        Valor individual estimado
                      </span>
                      <span className="text-xl font-bold text-brand-gold" data-id="element-737" data-mp="2l1jhbspw1nu4">
                        {bonus.value}
                      </span>
                    </div>
                  </div>
                </article>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.12} data-id="element-738" data-mp="329surjrr7848">
            <section className="mt-12 overflow-hidden rounded-3xl border border-brand-gold/25 bg-brand-green px-5 py-10 text-white shadow-[0_24px_55px_-30px_rgba(31,61,43,0.75)] sm:px-10 sm:py-14" data-id="element-739" data-mp="32augqjab5f0q">
              <div className="mx-auto max-w-3xl text-center" data-id="element-740" data-mp="2sjzs589la3c4">
                <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-brand-gold/35 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-741" data-mp="2xj3ylr54pmyr">
                  <Sparkles className="h-4 w-4" data-id="element-742" data-mp="2ojgyd8o4yn7a" />
                  Una inversión inteligente
                </div>

                <h2 className="font-serif text-3xl font-bold leading-tight tracking-tight sm:text-4xl md:text-5xl" data-id="element-743" data-mp="29mq8bq0cqnuc">
                  Todo lo que recibirás hoy con tu acceso
                </h2>
                <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-744" data-mp="7u22d8wbpmav">
                  No estás comprando únicamente un curso. Obtienes un sistema
                  completo con herramientas, recursos y guías diseñadas para
                  ayudarte a vender en Amazon con mayor rapidez y evitando
                  errores costosos.
                </p>

                <section aria-labelledby="complete-systems-title" className="mt-9 border-y border-brand-gold/30 py-8 sm:mt-10 sm:py-10 lg:-mx-16 lg:w-[calc(100%+8rem)]" data-id="element-745" data-mp="ecximlkq1wpv">
                  <div className="mx-auto mb-7 max-w-2xl text-center sm:mb-9" data-id="element-746" data-mp="1724qib62fyns">
                    <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-747" data-mp="1c06bj1n1y81w">
                      Dos sistemas completos incluidos
                    </p>
                    <h3 id="complete-systems-title" className="mt-3 font-serif text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-748" data-mp="121gs34ficfjj">
                      Recibe dos programas premium, no un curso aislado.
                    </h3>
                  </div>

                  <div className="grid grid-cols-1 gap-6 text-left md:grid-cols-2 md:gap-7" data-id="element-749" data-mp="24t1dc3vzsczn">
                    {completeSystems.map(system => <article key={system.label} className="group overflow-hidden rounded-2xl border border-brand-gold/35 bg-white p-3 text-brand-text shadow-[0_18px_38px_-25px_rgba(0,0,0,0.8)] transition duration-500 ease-out hover:-translate-y-1 hover:shadow-[0_28px_52px_-22px_rgba(0,0,0,0.85)] sm:p-4" data-id="element-750" data-mp="2dv107ctoubai">
                        <div className="overflow-hidden rounded-xl border border-brand-gold/25 bg-brand-beige/45 transition-shadow duration-500 group-hover:shadow-[0_20px_42px_-22px_rgba(31,61,43,0.65)]" data-id="element-751" data-mp="1h2xc236a0pbt">
                          <img src={system.image} alt={system.alt} loading="lazy" className="h-auto w-full object-contain transition-transform duration-700 ease-out group-hover:scale-[1.04]" data-id="element-752" data-mp="1q3lpowrrcno6" />
                        </div>

                        <div className="px-2 pb-2 pt-5 sm:px-3 sm:pt-6" data-id="element-753" data-mp="32gsjzi3md7f9">
                          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-754" data-mp="378k4pc03gixh">
                            {system.label}
                          </p>
                          <h4 className="mt-2 text-xl font-bold text-brand-green sm:text-2xl" data-id="element-755" data-mp="2ekeiekte6lvj">
                            {system.title}
                          </h4>

                          <ul className="mt-4 grid grid-cols-1 gap-2 border-t border-brand-text/10 pt-4 sm:grid-cols-2 sm:gap-x-3" data-id="element-756" data-mp="2jlc06wahpdwi">
                            {system.features.map(feature => <li key={feature} className="flex items-center gap-2 text-sm font-medium leading-snug text-brand-text/75" data-id="element-757" data-mp="2tfcbjfwd7fdo">
                                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-green/10" data-id="element-758" data-mp="1t9qo2f7f4bws">
                                  <Check className="h-3 w-3 text-brand-green" strokeWidth={3} data-id="element-759" data-mp="1obgqjxy80z80" />
                                </span>
                                {feature}
                              </li>)}
                          </ul>
                        </div>
                      </article>)}
                  </div>

                  <div className="mt-7 rounded-2xl border border-white/15 bg-white/5 p-5 text-left sm:mt-9 sm:p-7" data-id="element-760" data-mp="10jrxgfdks6q0">
                    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-white/15 pb-4" data-id="element-761" data-mp="vmry0nb8e27v">
                      <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-762" data-mp="2uxt25gvt3ny0">
                        Bonos premium incluidos
                      </p>
                      <p className="text-xs font-semibold text-white/70" data-id="element-763" data-mp="1nnejgir0aeug">
                        6 recursos profesionales
                      </p>
                    </div>
                    <ul className="mt-4 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-764" data-mp="1dop1kpz40ue7">
                      {bonuses.map(bonus => <li key={bonus.title} className="flex items-start justify-between gap-4" data-id="element-765" data-mp="1il5ppk6b78ra">
                          <span className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-766" data-mp="18puhlkpeozsi">
                            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-gold/20" data-id="element-767" data-mp="uypf8aunlteh">
                              <Check className="h-3 w-3 text-brand-gold" strokeWidth={3} data-id="element-768" data-mp="zu4sb0ku7l9u" />
                            </span>
                            {bonus.title}
                          </span>
                          <span className="shrink-0 text-sm font-bold text-brand-gold" data-id="element-769" data-mp="6em4cntc5hmn">
                            {bonus.value}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </section>

                <div className="mt-9 overflow-hidden rounded-2xl border border-white/15 bg-white text-left shadow-[0_18px_38px_-22px_rgba(0,0,0,0.55)]" data-id="element-770" data-mp="bab4otd6j2k0">
                  <div className="divide-y divide-brand-text/10" data-id="element-771" data-mp="labpykulzsqu">
                    <div className="flex items-center justify-between gap-4 px-5 py-5 sm:px-7" data-id="element-772" data-mp="l7zbiho280ij">
                      <div data-id="element-773" data-mp="z31eavxm19r4">
                        <p className="font-bold text-brand-green" data-id="element-774" data-mp="u1lvlaiwnfbw">
                          Programa Principal Amazon Master System™
                        </p>
                        <p className="mt-1 text-xs text-brand-text/55" data-id="element-775" data-mp="18xa8do2ahare">
                          Formación paso a paso para empezar con claridad.
                        </p>
                      </div>
                      <span className="shrink-0 text-xl font-bold text-brand-green sm:text-2xl" data-id="element-776" data-mp="1b1na6biv7jvd">
                        $97 USD
                      </span>
                    </div>
                    <div className="flex items-center justify-between gap-4 px-5 py-5 sm:px-7" data-id="element-777" data-mp="1l0cvke9yzmgd">
                      <div data-id="element-778" data-mp="1ptp4lg261ko0">
                        <p className="font-bold text-brand-green" data-id="element-779" data-mp="1urh9danwt19m">
                          Biblioteca Premium Incluida
                        </p>
                        <p className="mt-1 text-xs font-semibold uppercase tracking-[0.12em] text-brand-gold" data-id="element-780" data-mp="1yrrcmfkbhdks">
                          6 Recursos Profesionales
                        </p>
                      </div>
                      <span className="shrink-0 text-xl font-bold text-brand-green sm:text-2xl" data-id="element-781" data-mp="28qgx8g3llc4q">
                        $154 USD
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between gap-4 bg-brand-beige/70 px-5 py-5 sm:px-7" data-id="element-782" data-mp="edh89wdbv5ks">
                    <span className="font-serif text-xl font-bold text-brand-green sm:text-2xl" data-id="element-783" data-mp="6vj5sbtkcur2">
                      Valor total del paquete
                    </span>
                    <span className="shrink-0 text-3xl font-bold tracking-tight text-brand-green sm:text-4xl" data-id="element-784" data-mp="3t9sqa9udhimk">
                      $251 USD
                    </span>
                  </div>
                </div>

                <button type="button" onClick={goToCheckout} aria-label="Comenzar ahora" className="mt-8 w-full rounded-2xl border border-brand-gold/40 bg-brand-green p-5 text-center shadow-xl shadow-black/20 transition-colors duration-200 hover:bg-brand-green/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 focus-visible:ring-offset-brand-green sm:p-7" data-id="element-785" data-mp="prsojcfeu9he">
                  <span className="grid items-center gap-5 sm:grid-cols-[0.85fr_auto_1.15fr] sm:gap-7" data-id="element-786" data-mp="2vnn2b5m79a9g">
                    <span className="text-center sm:text-right" data-id="element-787" data-mp="3lc0vhx8abzzh">
                      <span className="block text-[11px] font-bold uppercase tracking-[0.16em] text-white/70" data-id="element-788" data-mp="3q9kbb1kmsktj">
                        Valor real
                      </span>
                      <span className="mt-1 block text-3xl font-bold text-white/80 line-through decoration-brand-gold sm:text-4xl" data-id="element-789" data-mp="3g9te2s4orrpr">
                        $251 USD
                      </span>
                    </span>

                    <span className="mx-auto block h-px w-14 bg-brand-gold/70 sm:h-14 sm:w-px" data-id="element-790" data-mp="csjlgj8ie23p" />

                    <span className="text-center sm:text-left" data-id="element-791" data-mp="3v72k8rynf01j">
                      <span className="block text-xs font-bold uppercase tracking-[0.15em] text-brand-gold" data-id="element-792" data-mp="33jhelf5ggin">
                        Acceso inmediato por solo
                      </span>
                      <span className="mt-1 block text-5xl font-bold leading-none tracking-[-0.05em] text-white sm:text-6xl md:text-7xl" data-id="element-793" data-mp="vk3yue02m3wj">
                        $27.99
                        <span className="ml-2 text-lg tracking-normal sm:text-xl" data-id="element-794" data-mp="2g8ojh6htcxvp">
                          USD
                        </span>
                      </span>
                    </span>
                  </span>

                  <span className="mt-6 inline-flex items-center justify-center rounded-xl border border-white/20 bg-white px-5 py-3 text-sm font-bold tracking-wide text-brand-green" data-id="element-795" data-mp="2l1hl3lhzjq3k">
                    COMENZAR AHORA
                  </span>
                </button>

                <p className="mx-auto mt-8 max-w-2xl text-sm leading-relaxed text-white/80 sm:text-base" data-id="element-796" data-mp="1sen4izoahavd">
                  Con un solo pago obtienes acceso inmediato al programa
                  completo y a todos los recursos premium incluidos.
                </p>
                <div className="mx-auto mt-5 grid max-w-2xl grid-cols-2 gap-x-4 gap-y-3 border-t border-white/15 pt-5 text-left text-xs font-medium text-white/75 sm:grid-cols-4 sm:text-center" data-id="element-797" data-mp="3io6xmpabdl3o">
                  <span data-id="element-798" data-mp="ga0juob2kr64">Sin pagos mensuales.</span>
                  <span data-id="element-799" data-mp="gatui0d5g0tj">Sin costos ocultos.</span>
                  <span data-id="element-800" data-mp="baxojvkw5zbc">Acceso de por vida.</span>
                  <span data-id="element-801" data-mp="bc8uo21t7j5m">Actualizaciones incluidas.</span>
                </div>

                <Button onClick={goToCheckout} aria-label="Comenzar ahora" className="mt-9 w-full sm:w-auto" data-id="element-802" data-mp="paysjjwgdmv1">
                  COMENZAR AHORA
                </Button>

                <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/60" data-id="element-803" data-mp="u906jqf0uvzn">
                  <span className="flex items-center gap-1.5" data-id="element-804" data-mp="17yvb8c6u2w7k">
                    <Zap className="h-3.5 w-3.5 text-brand-gold" data-id="element-805" data-mp="13ytl90agnr84" />
                    Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-806" data-mp="1hze23qwtfcyz">
                    <Check className="h-3.5 w-3.5 text-brand-gold" data-id="element-807" data-mp="1cz9ihs0m224j" />
                    Todo incluido
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-808" data-mp="1wkry7u1jakes">
                    <ShieldCheck className="h-3.5 w-3.5 text-brand-gold" data-id="element-809" data-mp="21k4iq84xnfe7" />
                    Pago seguro
                  </span>
                </div>
              </div>
            </section>
          </FadeIn>
        </div>
      </div>
    </section>;
}